export default class Menu {
    constructor() {
        let self = this;
        self.html = document.querySelector('html');
        self.toggleButton = document.querySelector('#menu-toggle');
        self.menuHeader = document.querySelector('header');
        self.menuArrows = document.querySelectorAll('.menu-item-has-children > .menu-arrow');
        self.menuSubmenus = document.querySelectorAll('.menu-item-has-children > .sub-menu');
        if (!self.toggleButton) {
            return;
        }
        self.menuTitles = [
            self.toggleButton.getAttribute('data-title-menu'),
            self.toggleButton.getAttribute('data-title-close')
        ];
        self.toggleButtonTitle = self.toggleButton.querySelector('span.title');
        self.arrowClickEvent();
        self.submenuMouseEvents();
        this.menuEventListeners();
    }
    menuEventListeners() {
        const self = this;
        this.toggleButton.addEventListener('click', function (e) {
            e.preventDefault();
            self.menuToggleMobile();
        });
    }
    menuToggleMobile() {
        const self = this;
        self.toggleButton.classList.toggle('is-open');
        self.menuHeader.classList.toggle('is-open');
        self.html.classList.toggle('no-scroll');
        self.toggleButton.querySelector('span.title').textContent = self.toggleButton.classList.contains('is-open') ? self.menuTitles[1] : self.menuTitles[0];
    }
    arrowClickEvent() {
        const self = this;
        self.menuArrows.forEach(function (arrow) {
            arrow.addEventListener('click', function (e) {
                e.preventDefault();
                const isOpen = arrow.parentElement.classList.contains('is-open');
                self.menuArrows.forEach(function (submenu) { submenu.parentElement.classList.remove('is-open'); });
                if (!isOpen) {
                    arrow.parentElement.classList.add('is-open');
                }
            });
        });
    }
    submenuMouseEvents() {
        const self = this;
        self.menuSubmenus.forEach(function (subMenu) {
            subMenu.addEventListener('mouseleave', function (e) {
                e.stopPropagation();
                subMenu.parentElement.classList.remove('is-open');
            });
        });
    }
}
